export function ContentCardBody({ children }) {
  return <div className="d-flex flex-column">{children}</div>;
}
